import { React } from "react";
import useAxios from "../../../../utilities/useAxios";
import PageTitle from "../../../PageTitle";
import { Form, Input, Button, Card, message } from "antd";
import { useNavigate } from "react-router-dom";

const AddAccessedCar = () => {
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const onFinish = async (values) => {
		try {
			const response = await useAxios.post(
				"/utils/accessed-car/",
				{
					car_num: values.car_num,
					owner: values.owner,
					owner_tel: values.owner_tel,
					inst: values.inst,
					inst_detail: values.inst_detail || null,
				}
			);

			if (response.status === 201) {
				message.success(
					"차량이 성공적으로 등록되었습니다."
				);
				// Trigger refresh in parent component
				if (
					window.opener &&
					window.opener.refreshAccessedCars
				) {
					window.opener.refreshAccessedCars();
				}
				window.close();
			}
		} catch (error) {
			message.error(
				error.response?.data?.message ||
					"차량 등록 중 오류가 발생했습니다."
			);
		}
	};

	return (
		<>
			<PageTitle title="신규 차량 등록" />
			<div className="utils-accessed_car__container">
				<div className="utils-accessed_car__header">
					<h1 className="utils-accessed_car__header__title">
						신규 차량 등록
					</h1>
				</div>
				<div className="utils-accessed_car__content-container">
					<Card className="utils-accessed_car__form-card">
						<Form
							form={form}
							layout="vertical"
							onFinish={onFinish}
							autoComplete="off">
							<Form.Item
								label="차주"
								name="owner"
								rules={[
									{
										required: true,
										message: "차주를 입력해주세요",
									},
								]}>
								<Input placeholder="차주 이름을 입력하세요" />
							</Form.Item>

							<Form.Item
								label="소속"
								name="inst"
								rules={[
									{
										required: true,
										message: "소속을 입력해주세요",
									},
								]}>
								<Input placeholder="소속을 입력하세요" />
							</Form.Item>

							<Form.Item
								label="세부소속"
								name="inst_detail">
								<Input placeholder="세부소속을 입력하세요" />
							</Form.Item>

							<Form.Item
								label="차량번호"
								name="car_num"
								rules={[
									{
										required: true,
										message: "차량번호를 입력해주세요",
									},
								]}>
								<Input placeholder="차량번호를 입력하세요" />
							</Form.Item>

							<Form.Item
								label="차주 연락처"
								name="owner_tel"
								rules={[
									{
										pattern: /^[0-9-]+$/,
										message: "숫자와 하이픈(-)만 입력 가능합니다",
										required: true,
									},
								]}>
								<Input placeholder="연락처를 입력하세요" />
							</Form.Item>

							<Form.Item>
								<div className="utils-accessed_car__form-actions">
									<Button
										type="primary"
										htmlType="submit">
										추가
									</Button>
									<Button
										onClick={() =>
											navigate(
												-1
											)
										}>
										취소
									</Button>
								</div>
							</Form.Item>
						</Form>
					</Card>
				</div>
			</div>
		</>
	);
};

export default AddAccessedCar;
